import { useContext, useEffect, useState } from 'react';
import { CreateBookingFormContext, formActions } from '../CreateBookingForm.context';

const useSelectRoomsHook = ({ onNext }) => {
  const initialRooms = [
    {
      type: 'single',
      price: '50',
      available: 8,
      booked: 0,
      bookings: [],
    },
    {
      type: 'standardDouble',
      price: '70',
      available: 10,
      booked: 0,
      bookings: [],
    },
    {
      type: 'doubleDelux',
      price: '100',
      available: 10,
      booked: 0,
      bookings: [],
    },
    {
      type: 'suite',
      price: '250',
      available: 3,
      booked: 0,
      bookings: [],
    },
  ];
  const { formState, dispatch } = useContext(CreateBookingFormContext);
  const [state, setState] = useState({ rooms: [] });

  useEffect(() => {
    dispatch({ type: formActions.RESET_FORM_ROOMS });
    let rooms = initialRooms;
    // const { roomsDetails } = formState;
    // if (roomsDetails) {
    //   rooms = roomsDetails;
    // }
    actions.initializeState({ rooms });
  }, []);

  const actions = {
    initializeState: ({ rooms }) => {
      updateState({ rooms });
    },
    onAddRoom: ({ index, adults, children, quantity }) => {
      quantity = quantity === 0 ? 1 : quantity;
      const booking = { rooms: quantity, adults, children };
      const newRooms = state.rooms.map((room, roomIndex) => {
        if (roomIndex === index) {
          room.available -= quantity;
          room.booked += quantity;
          room.bookings.push(booking);
        }
        return room;
      });
      updateState({ rooms: newRooms });
      dispatch({ type: formActions.SET_ROOM_DETAILS, payload: newRooms });
      onNext();
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useSelectRoomsHook;
